/* istanbul ignore next */
export const noop = (_?: any) => {};


// WEBPACK FOOTER //
// ./src/lib/components/common/noop.ts